var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v(_vm._s(_vm.i18n.app.components.about.about))])
}
var staticRenderFns = []

export { render, staticRenderFns }